// extracted by mini-css-extract-plugin
export var csatScore = "_n8-5";
export var header = "_n8-1";
export var panelWrapper = "_n8-2";
export var postPreview = "_n8-3";
export var rightContent = "_n8-0";
export var wrappingText = "_n8-4";